/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { createResource, type RouteResource } from '@atlassian/react-resource-router';
import type { LinkedSourcesResponse } from './LinkedSourcesResponse.types.tsx';

export const servicedeskKnowledgeBaseLinkedSourcesResource: RouteResource<LinkedSourcesResponse> =
	createResource<LinkedSourcesResponse>({
		type: 'SERVICEDESK_KNOWLEDGE_BASE_LINKED_SOURCES',
		getKey: ({ match }) => match.params.projectKey || '',
		getDataLoader: () =>
			import(
				/* webpackChunkName: "async-resource-servicedesk-knowledge-base-linked-sources", jiraSpaEntry: "async-resource-servicedesk-knowledge-base-linked-sources" */ './getData.tsx'
			),
		maxAge: 30 * 60 * 1000, // 30 minutes
		isBrowserOnly: true, // making it a browser only resource until BE API is ready
	});
